module.exports = "/static/assets/76602ba3bf56e6ba492223964ae32e5a.png";